<script>
import Endpoints from '../../../components/common/Endpoints';
import Common from '../../../components/common/Common';
import Request from '../../../components/common/Request';

let type = "TRUCK_TRAILER";

export default {
       
    
   
    methods:{
        init: (payload) => {

            const el = document.body;
            el.removeAttribute("class");

            payload.domain = Endpoints.domain;

            //GET COMPANY ID
            let company = payload.$session.get('user').companyUser.company._id;
            payload.data.company = company;

            if(payload.data.actualKM){
                payload.data.actualKM = Number(String(payload.actualKM).replace(/\//g, '').replace(/\./g, '').replace(/\-/g, ''));
            }

            setTimeout(async function(){
                let query = {
                    type: type
                };

                let response = (await Request.do(payload, 'GET', Request.getDefaultHeader(payload), {}, `${Endpoints.systemUsers.getMe}`)).data;
                if (response.status==200){
                    let responseManu = (await Request.do(payload, 'POST', Request.getDefaultHeader(payload), query, `${Endpoints.parts.manufacturer.listByType}`)).data;
                    payload.manufacturers = responseManu.results;

                    let responseCertifies = await Request.do(payload, 'GET', Request.getDefaultHeader(payload), {}, `${Endpoints.parts.certifies.list}`);
                    payload.certifies = responseCertifies.data.results;

                    let responsetruckTrailerTypes = await Request.do(payload, 'GET', Request.getDefaultHeader(payload), {}, `${Endpoints.helpers.listTruckTrailer}`);
                    payload.truckTrailerTypes = responsetruckTrailerTypes.data.results;
                    
                    let responseSpeciesTypes = await Request.do(payload, 'GET', Request.getDefaultHeader(payload), {}, `${Endpoints.helpers.listSpeciesTypes}`);
                    payload.speciesTypes = responseSpeciesTypes.data.results;

                    let trucker = (await Request.do(payload, 'POST', Request.getDefaultHeader(payload),{status:'ACTIVE',company:response.result.companyUser.company._id},
                        `${Endpoints.systemUsers.filter}`));
                    if (trucker.status==200){
                        payload.truckers = trucker.data.results;
                    }

                }
            }, 100);
        
            let manufacturer = JSON.parse(JSON.stringify(payload.manufacturers));

            payload.reorderManufacturer(manufacturer);
        
        },
        save: function(){
            $('#spinner').modal('toggle');

            this.errors = [];
            this.messageIdToast = null;

            let state = this;
            let data = JSON.parse(JSON.stringify(this.data));

            let company = this.$session.get('user').companyUser.company._id;
            data.company = company;

            let formData = new FormData();
            formData.append('file', this.file);
            formData.append('jsonData', JSON.stringify(data));

            Request.do(this, this.data._id ? 'PUT' : 'POST', Request.getDefaultHeader(this), formData, `${Endpoints.trucks.truckFormData}${this.data._id ? this.data._id : ''}`,
                (response)=>{//SUCCESS CALLBACK
                    state.data._id = response.result._id;
                    state.data.documentPhotoURL = response.result.documentPhotoURL;
                    state.valuekey += 1;
                    $('#spinner').modal('toggle');
                    if (!data._id){
                        this.flashMessage.success(
                            this.configMessage(this.$t('string.msg.truck.trailer.register.title.success'), this.$t('string.msg.truck.trailer.register.message.success'), 'top left', 3000),
                        {
                            mounted: this.showText(this.$t('string.msg.truck.trailer.register.message.success')),
                            destroyed: this.clearText()
                        })
                    } else{
                        this.flashMessage.info(
                            this.configMessage(this.$t('string.msg.truck.trailer.register.title.alter'), this.$t('string.msg.truck.trailer.register.message.alter'), 'top left', 3000),
                        {
                            mounted: this.showText(this.$t('string.msg.truck.trailer.register.message.alter')),
                            destroyed: this.clearText()
                        })
                    }
                    },
                (error)=>{//ERROR CALLBACK
                 console.log(this.formData);
                    $('#spinner').modal('toggle');
                    let res = error.response;
                    if (res && res.status){
                        this.titleToast = this.$t("string.msg.warning");
                        
                        if (res.data.messageId === 'response.msg.error.empty.fields'){
                            let fields = "";
                            res.data.errors.forEach(function (value) {
                                fields += state.$t(value.id)+";<br/>";
                            });
                            this.titleToast = this.$t(res.data.messageId);
                            this.messageToast = this.$t(fields);
                        }else{
                            this.messageToast = this.$t(res.data.messageId);
                            this.messageIdToast = res.data.messageId;
                        }

                        $('#toast').modal('show');
                    }
                    console.log(JSON.stringify(error));
            });
        },
        selectItem: function(item){
            this.data = JSON.parse(JSON.stringify(item));
       
            let manufacturer = null;
            if(this.data.manufacturer){
                 manufacturer =  this.data.manufacturer
                this.onChange(manufacturer)
            }
            
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

        },
        archive: function(response){
            if (response==1){
                $('#spinner').modal('toggle');
                this.errors = [];
                this.messageIdToast = null;
                let state = this;
                
                Request.do(this, 'DELETE', Request.getDefaultHeader(this), this.data, `${Endpoints.trucks.truck}${this.data._id}`,
                    (companyResponse)=>{//SUCCESS CALLBACK

                        $('#spinner').modal('toggle');

                        this.$eventHub.$emit('refreshList');

                        this.flashMessage.warning(
                            this.configMessage(this.$t('string.msg.truck.trailer.register.title.filed'), this.$t('string.msg.truck.trailer.register.message.filed'), 'top left', 2500),
                        {
                            mounted: this.showText(this.$t('string.msg.truck.trailer.register.message.filed')),
                            destroyed: this.clearText()
                        })
                        
                        setTimeout(function(){ 
                            location.reload();
                            this.$forceUpdate();
                        },500);
                    },
                    (error)=>{//ERROR CALLBACK
                        $('#spinner').modal('toggle');
                        let res = error.response;
                        if (res && res.status){
                            this.titleToast = this.$t("string.msg.warning");
                            if (res.data.messageId === 'response.msg.error.empty.fields'){
                                let fields = "";
                                res.data.errors.forEach(function (value) {
                                    fields += state.$t(value.id)+";<br/>";
                                });
                                this.titleToast = this.$t(res.data.messageId);
                                this.messageToast = this.$t(fields);
                            }else{
                                this.messageToast = this.$t(res.data.messageId);
                                this.messageIdToast = res.data.messageId;
                            }

                            $('#toast').modal('show');
                        }
                        console.log(JSON.stringify(error));
                });
            }
        },
         confirmArchive: function(item){
               if (this.data.model) {
                this.titleToast = this.$t("string.msg.confirm");
                this.messageToast = this.$t("response.archive.trucktrailer.confirmation");
                this.cancelText = this.$t("string.msg.cancel");
                this.yesText = this.$t("string.msg.yes");
                $('#confirmationModal').modal('show');
            }else{
                this.errors = [];
                this.errors.push(this.$t('response.truck.register.model.required.for.archive'));
            }
        },
        handleFileUpload(){
            this.file = this.$refs.file.files[0];
        },
        
        clearForm: function(){
            this.data = {},
            this.data.manufacturer = {},
            this.data.systemUsers = {},
            this.data.certifies = {},
            this.certifie = null;
            this.errors = {};
            this.expiredDate = null,
            this.shippingDate = null

        },
        add: function (e) {

            let state = this;

            if(state.shippingDate){
                let day,month,year;
                day = (state.shippingDate.slice(0,2));
                month = (state.shippingDate.slice(3,5));
                year = (state.shippingDate.slice(6,10));

                state.shippingDate = new Date();
                state.shippingDate.setDate(day);
                state.shippingDate.setMonth(month-1);
                state.shippingDate.setFullYear(year);
            }
            
            if(state.expiredDate){
                let day,month,year;
                day = (state.expiredDate.slice(0,2));
                month = (state.expiredDate.slice(3,5));
                year = (state.expiredDate.slice(6,10));

                state.expiredDate = new Date();
                state.expiredDate.setDate(day);
                state.expiredDate.setMonth(month-1);
                state.expiredDate.setFullYear(year);
            }  


            let cert = {
                certified:{
                    _id: state.certifie._id,
                    name: state.certifie.name,
                },
                shippingDate: state.shippingDate,
                expiredDate: state.expiredDate,
                photoURL: state.certifiePhotoURL
            }
            state.data.certifies.push(JSON.parse(JSON.stringify(cert)));

        },
        
        checkTable: function(){
            this.errors = [];
            if (!this.expiredDate) {
                this.errors.push(this.$t('response.truck.register.manufacturer.required'));
            }
            if (this.errors.length>0){
                e.preventDefault();
            }else{
                console.log(this.data);
                this.add();
            }
        },
        remove: function(_idCertified){
            let indexCert = this.data.certifies.findIndex(x => x.certified._id == _idCertified);
            if (indexCert > -1){
               this.data.certifies.splice(indexCert, 1);
            }
        },
         
        checkForm: function (e) {
            this.errors = [];
            if (!this.data.manufacturer) {
                this.errors.push(this.$t('response.truck.register.manufacturer.required'));
            }
            if (!this.data.plate) {
                this.errors.push(this.$t('response.truck.register.plate.required'));
            }
            // if (!this.data.model) {
            //     this.errors.push(this.$t('response.truck.register.model.required'));
            // }
            if (!this.data.specie) {
                 this.errors.push(this.$t('response.truck.register.groupType.required'));
             }
            if (this.errors.length>0){
                e.preventDefault();
            }else{
                this.save();
            }
        },
        showText(text) {
            this.text = text
        },
        showPhoto: function(url){
            this.photoURL = url;
             $('#modalPhoto').modal('show');

        },
        clearText() {
            setTimeout( () => this.text = '', 500);
        },
        configMessage :function(title, message, position, time){
            const config ={
               title: title,
                message: message,
                position: position,
                x: window.innerWidth /60,
                y: window.innerHeight /1.3,
                time: time,
            }
            return config
        },
        reorderManufacturer: function(manufacturer){
            
                let index = manufacturer.findIndex(x => x.name == 'Others');
                let others = null;
                if(index > -1){
                    others = manufacturer[index];
                    manufacturer.splice(index, 1);
                    manufacturer.push(others);
                }
                this.manufacturers = manufacturer;
        },
         camelize: Common.camelize,
         toUpperCase: Common.toUpperCase,
    }
}
</script>
